<template>
  <section>
    <h2 class="section-title">포트폴리오 제작용 아트워크 선택</h2>
    <div class="sort-panel">
      <div class="inner-box">
        <div class="l-cont">
          <div class="cont-wrap">
            <div class="category-wrap">
              <ul class="category">
                &nbsp;
              </ul>
              <div class="btn-wrap">
              </div>
            </div>
            <div class="sort-list-wrap">
              <div class="sort-list-content">
                <div class="sort-title">
                  <h3>전체 아트워크</h3>
                  <p>포트폴리오에 넣고 싶은 아트워크를 선택해보세요.</p>
                </div>
                <!-- 드래그 아이템 내용 -->

                <!-- 왼쪽 목록 -->
                <draggable
                    ref="leftArtWorkList"
                    v-model="filteredLeftArtWorks"
                    tag="ul"
                    group="artworkGroup"
                    item-key="uuid"
                    class="sort-list connected-sortable"
                    :class="{ 'disabled': isMoveDisabled }"
                    ghost-class="dragging"
                    @end="onDragEnd"
                    :disabled="isMoveDisabled"
                    :handle="'.left-handler'"
                >

                  <template #item="{ element }">
                    <li :data-uuid="element.uuid" class="draggable-item" :class="{ selected: selectedLeftArtWorks.includes(element.uuid) }"
                        @click="toggleLeftSelection(element.uuid)">
                      <!--                      <img class="dots" src="@/assets/images/icon/ico_drag.svg" alt="">-->
                      <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
                          <path d="M15.7439 1L6.92962 12.4675L1 4.8225" stroke="#151419" stroke-width="1.92857" stroke-linecap="round"
                                stroke-linejoin="round"/>
                        </svg>
                      </i>
                      <figure class="left-handler">
                        <img :src="element.imageUrl" :alt="element.title || element.titleEn" loading="lazy">
                      </figure>
                      <div class="mask txt" :class="{ 'left-handler' : !isMobile}">
                        <p>
                          {{ element.title || element.titleEn }}<br>
                          {{ element.size }}<br>
                          {{ element.year }}<br>
                        </p>
                      </div>
                    </li>
                  </template>
                </draggable>
              </div>
              <div class="sort-bottom">
                <button type="button" class="btn-line btn-insert" :disabled="selectedLeftArtWorks.length === 0" @click="moveSelectedToRight">
                  <span>리스트에 넣기</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="18" viewBox="0 0 8 18" fill="none">
                    <path
                        d="M-8.79878e-07 1.68512L0.780931 0.765626L8 9.26562L0.780933 17.7656L3.36909e-07 16.8461L6.43814 9.26563L-8.79878e-07 1.68512Z"
                        fill="#16151A"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- 카테고리에서 빼기 위치 변경 -->
        <button v-show="!isMoveDisabled" type="button" class="btn-line mobile btn-remove" :disabled="selectedRightArtWorks.length === 0"
                @click="moveSelectedToLeft">
          <span>리스트에서 빼기</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="8" viewBox="0 0 10 5" fill="none">
            <path d="M0.650645 4.7954L0.123047 4.34731L5.00026 0.205078L9.87748 4.34731L9.34988 4.7954L5.00026 1.10126L0.650645 4.7954Z"
                  fill="#FFF3CE"/>
          </svg>
        </button>
        <div class="r-cont">
          <div class="cont-wrap">
            <div class="cont-title">
              <p class="mo" v-show="!isMoveDisabled" style="font-size: 12px">&nbsp;</p>
            </div>
            <div ref="sortListWrapRef" class="sort-list-wrap no-bg">
              <div :class="['sort-list-border', { 'empty': !filteredRightArtWorks || filteredRightArtWorks.length === 0 }]">

                <!-- 오른쪽 목록 -->
                <draggable
                    ref="rightArtWorkList"
                    v-model="filteredRightArtWorks"
                    tag="ul"
                    group="artworkGroup"
                    item-key="uuid"
                    class="sort-list2 connected-sortable"
                    ghost-class="dragging"
                    @start="onDragStart"
                    @end="onDragEnd"
                    :move="onDragMove"
                    :handle="'.right-handler'"
                >
                  <template #item="{ element }">
                    <li :data-uuid="element.uuid" class="draggable-item"
                        :class="{ selected: selectedRightArtWorks.includes(element.uuid), 'right-handler': !isMobile }"
                        @click="!isMoveDisabled ? toggleRightSelection(element.uuid) : null">
                      <div class="dots right-remove" @click.stop="moveToLeft(element.uuid)">
                        <img v-if="!isMoveDisabled" src="@/assets/images/icon/ico_minus.svg" alt="">
                      </div>
                      <figure>
                        <img :src="element.imageUrl" :alt="element.title || element.titleEn" loading="lazy">
                      </figure>
                      <div class="mask txt">
                        <p class="title">{{ element.title || element.titleEn }}</p>
                        <p>
                          {{ element.size }}<br>
                          {{ element.year }}<br>
                        </p>
                      </div>
                      <div :class="{'right-handler': isMobile }">
                        <img src="@/assets/images/icon/ico_drag2.svg" alt="" draggable="true">
                      </div>
                    </li>
                  </template>
                </draggable>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<script setup>
import {computed, ref, watch} from 'vue';
import draggable from 'vuedraggable';
import {useDeviceStore} from "@/store/deviceStore";

const deviceStore = useDeviceStore();
const isMobile = computed(() => deviceStore.isMobile);

const props = defineProps({
  artWorks: Object,
  artWorksPortfolioCategory: String,
});

const allArtWorks = ref(null);
const selectedArtWorksCategory = ref(null); // 카테고리 사용안함.
const artWorksCategories = ref(null);
/* 아트워크 관리 모달 s */
watch(
    () => props.artWorks,
    (newVal) => {
      if (newVal) {
        allArtWorks.value = newVal;
        selectedArtWorksCategory.value = {uuid: props.artWorksPortfolioCategory, name: props.artWorksPortfolioCategory, isHidden: false};
        artWorksCategories.value = [{uuid: props.artWorksPortfolioCategory, name: props.artWorksPortfolioCategory, isHidden: false}]
      }
    },
);

const filteredLeftArtWorks = ref([]);
watch(
    () => selectedArtWorksCategory.value,
    (newCategory) => {
      if (!newCategory) {
        filteredLeftArtWorks.value = []; // 선택된 카테고리가 없으면 빈 배열 유지
      } else {
        const group = groupedLeftArtWorks.value.find(group => group.category === newCategory.uuid);
        filteredLeftArtWorks.value = group ? [...group.items] : [];
      }
    },
);

const filteredRightArtWorks = ref([]);
watch(
    [() => selectedArtWorksCategory.value, () => allArtWorks.value],
    ([newCategory, newAllArtWorks]) => {
      if (!newAllArtWorks.length) {
        return;
      } // allArtWorks가 비어있으면 실행 안 함.
      const newGroupedRightArtWorks = groupedRightArtWorks.value; // 최신 grouped 데이터 가져오기

      if (!newCategory) {
        const group = newGroupedRightArtWorks.find(group => group.category === 'ALL');
        filteredRightArtWorks.value = group ? [...group.items] : [];
      } else {
        const group = newGroupedRightArtWorks.find(group => group.category === newCategory.uuid);
        filteredRightArtWorks.value = group ? [...group.items] : [];
      }
    },
);

const updateArtworkPositions = () => {
  filteredRightArtWorks.value.forEach((rightArtWork, index) => {
    const item = allArtWorks.value.find(i => i.uuid === rightArtWork.uuid);
    if (item) {
      item.page = Math.floor(index / 2);
      item.side = index % 2 === 0 ? 'left' : 'right';
    }
  });
};

const isMoveDisabled = computed(() => !selectedArtWorksCategory.value);

const leftArtWorkList = ref(null);
const rightArtWorkList = ref(null);

const selectedLeftArtWorks = ref([]);
const selectedRightArtWorks = ref([]);

const sortListWrapRef = ref(null);
const scrollSpeed = 5 // 스크롤 속도
const scrollThreshold = 200; // 상단/하단 스크롤 범위
const isScrolling = ref(false);  // 스크롤 반복 여부

const updateItems = () => {

  // 1) DOM 순서를 기준으로 uuid를 추출
  const leftUuids = leftArtWorkList.value.modelValue.map(el => el.uuid);
  const rightUuids = rightArtWorkList.value.modelValue.map(el => el.uuid);

  // 2) 조건에 따라 업데이트 분기 처리
  if (!selectedArtWorksCategory.value) {
    if (leftUuids.length > 0) {
      console.error("err")
      return;
    }
    rightUuids.forEach((uuid, index) => {
      const item = allArtWorks.value.find(i => i.uuid === uuid);
      if (item) {
        item.sortOrder = index;
      }
    });
  } else {
    // 특정 카테고리 선택: categoryUuid, categorySortOrder 값을 업데이트
    leftUuids.forEach((uuid, index) => {
      const item = allArtWorks.value.find(i => i.uuid === uuid);
      if (item) {
        item.categoryUuid = null;
        item.categorySortOrder = null;
      }
    });
    rightUuids.forEach((uuid, index) => {
      const item = allArtWorks.value.find(i => i.uuid === uuid);
      if (item) {
        item.categoryUuid = selectedArtWorksCategory.value.uuid;
        item.categorySortOrder = index;
        // item.page = Math.floor(index / 2);
        // item.side = index % 2 === 0 ? 'left' : 'right';
      }
    });
    updateArtworkPositions();
  }
  selectedLeftArtWorks.value = [];
  selectedRightArtWorks.value = [];

};

const groupedLeftArtWorks = computed(() => {
  const groups = {};
  artWorksCategories.value.forEach(category => {
    allArtWorks.value.forEach(artWork => {
      if (!artWork.categoryUuid) {
        const key = category.uuid;
        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push(artWork);
      }
    });
  })

  // 그룹 내에서는 sortOrder 기준으로 정렬
  Object.keys(groups).forEach(key => {
    groups[key].sort((a, b) => a.sortOrder - b.sortOrder);
  });

  return Object.entries(groups).map(([category, items]) => ({category, items}));
});

const groupedRightArtWorks = computed(() => {
  const groups = {};

  allArtWorks.value.forEach(artWork => {
    // categoryUuid가 존재하고 categorySortOrder가 정의되어 있으면 해당 카테고리 그룹에 넣습니다.
    if (artWork.categoryUuid && artWork.categorySortOrder != null) {
      const key = artWork.categoryUuid;
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(artWork);
    }

    // 모든 작품을 "ALL" 그룹에 넣고 sortOrder 기준으로 정렬합니다.
    const key = "ALL";
    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(artWork);
  });

  // 각 그룹 내 정렬: "ALL" 그룹은 sortOrder, 나머지 그룹은 categorySortOrder 기준 정렬
  Object.keys(groups).forEach(key => {
    if (key === "ALL") {
      groups[key].sort((a, b) => a.sortOrder - b.sortOrder);
    } else {
      groups[key].sort((a, b) => a.categorySortOrder - b.categorySortOrder);
    }
  });
  // 템플릿에서 쉽게 반복할 수 있도록 배열 형태로 변환
  return Object.entries(groups).map(([category, items]) => ({category, items}));
});

const toggleLeftSelection = (artWorkUuid) => {
  const index = selectedLeftArtWorks.value.indexOf(artWorkUuid);
  if (index === -1) {
    selectedLeftArtWorks.value.push(artWorkUuid);
  } else {
    selectedLeftArtWorks.value.splice(index, 1);
  }
};

const toggleRightSelection = (artWorkUuid) => {
  const index = selectedRightArtWorks.value.indexOf(artWorkUuid);
  if (index === -1) {
    selectedRightArtWorks.value.push(artWorkUuid);
  } else {
    selectedRightArtWorks.value.splice(index, 1);
  }
};

// 선택된 아이템들을 오른쪽(카테고리 영역)으로 이동시키는 함수
const moveSelectedToRight = () => {
  if (!selectedArtWorksCategory.value) {
    alert("먼저 카테고리를 선택해주세요.");
    return;
  }

  selectedLeftArtWorks.value.forEach(uuid => {
    const artWork = allArtWorks.value.find(item => item.uuid === uuid);
    if (artWork) {
      // 선택된 카테고리의 uuid를 할당하여 오른쪽 리스트로 이동 처리
      artWork.categoryUuid = selectedArtWorksCategory.value.uuid;
      // 오른쪽 리스트의 마지막 순서 번호에 맞춰 categorySortOrder를 할당할 수 있습니다.
      artWork.categorySortOrder = filteredRightArtWorks.value.length;
      filteredRightArtWorks.value = [...filteredRightArtWorks.value, artWork]; //filteredRightArtWorks.value.push(artWork); watch 감지하게 변경
    }
  });

  filteredLeftArtWorks.value = filteredLeftArtWorks.value.filter(
      item => !selectedLeftArtWorks.value.includes(item.uuid)
  );

  // 이동 후 선택 상태 초기화
  selectedLeftArtWorks.value = [];
  updateArtworkPositions();
};

const moveSelectedToLeft = () => {
  if (!selectedArtWorksCategory.value) {
    alert("먼저 카테고리를 선택해주세요.");
    return;
  }

  selectedRightArtWorks.value.forEach(uuid => {
    const artWork = allArtWorks.value.find(item => item.uuid === uuid);
    if (artWork) {
      // 선택된 카테고리의 uuid를 할당하여 오른쪽 리스트로 이동 처리
      artWork.categoryUuid = null;
      // 오른쪽 리스트의 마지막 순서 번호에 맞춰 categorySortOrder를 할당할 수 있습니다.
      artWork.categorySortOrder = null;
      filteredLeftArtWorks.value.push(artWork);
    }
  });

  filteredRightArtWorks.value = filteredRightArtWorks.value.filter(
      item => !selectedRightArtWorks.value.includes(item.uuid)
  );

  // 이동 후 선택 상태 초기화
  selectedRightArtWorks.value = [];
  updateArtworkPositions();
};

const moveToLeft = (uuid) => {
  // 선택한거 취소하고 넘기기
  // selectedRightArtWorks.value = [uuid];
  // moveSelectedToLeft();

  // 선택 유지하면서 넘기기
  const artWork = allArtWorks.value.find(item => item.uuid === uuid);
  if (artWork) {
    // 선택된 카테고리의 uuid를 할당하여 오른쪽 리스트로 이동 처리
    artWork.categoryUuid = null;
    // 오른쪽 리스트의 마지막 순서 번호에 맞춰 categorySortOrder를 할당할 수 있습니다.
    artWork.categorySortOrder = null;
    filteredLeftArtWorks.value.push(artWork);
  }

  filteredRightArtWorks.value = filteredRightArtWorks.value.filter(item => item.uuid !== uuid);
  selectedRightArtWorks.value = selectedRightArtWorks.value.filter(item => item !== uuid);
  updateArtworkPositions();
}

const setCategory = (category) => {
  if (category) {
    if (!selectedArtWorksCategory.value || selectedArtWorksCategory.value.uuid !== category.uuid) {
      selectedArtWorksCategory.value = category;
    }
  } else {
    if (selectedArtWorksCategory.value) {
      selectedArtWorksCategory.value = null;
    }
  }

  selectedLeftArtWorks.value = [];
  selectedRightArtWorks.value = [];
};

const disableScroll = () => {
  if (modalManageArtworkRef.value) {
    modalManageArtworkRef.value.style.overflow = 'hidden'
    // document.body.addEventListener('touchmove', preventDefault, { passive: false })
  }
}

const enableScroll = () => {
  if (modalManageArtworkRef.value) {
    modalManageArtworkRef.value.style.overflow = 'auto'
    // document.body.removeEventListener('touchmove', preventDefault)
  }
}

const onDragStart = (e) => {
  if (isMobile.value) {
    //disableScroll() // 드래그 시작 시 스크롤 비활성화
    // sortListWrapRef.value.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

const onDragEnd = (e) => {
  if (e.from.className == e.to.className && e.from.className == 'sort-list connected-sortable') {
    return false;
  }

  if (isMobile.value) {
    //enableScroll(); // 모바일일 때만 enableScroll 호출
  }
  updateItems();
  isScrolling.value = false;
}

// `onDragMove` 이벤트에서 스크롤 방향 감지
const onDragMove = (event) => {
  if (!sortListWrapRef.value) {
    return;
  }

  const {top, bottom} = sortListWrapRef.value.getBoundingClientRect();
  const currentPos = event.originalEvent.clientY;
  if (currentPos < top + scrollThreshold) {
    handleScroll(-1); // 위로 스크롤
  } else if (currentPos > bottom - scrollThreshold) {
    handleScroll(1); // 아래로 스크롤
  } else {
    isScrolling.value = false; // 스크롤 중지
  }
};

const handleScroll = (direction) => {
  const scrollContainer = document.querySelector('.sort-list2');

  const smoothScroll = () => {
    if (!isScrolling.value) {
      return;
    } // 스크롤 중지되면 종료

    const maxScrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight; // 최대 스크롤 값
    const currentScrollTop = scrollContainer.scrollTop; // 현재 스크롤 위치
    if ((direction === -1 && currentScrollTop <= 0) || (direction === 1 && currentScrollTop >= maxScrollTop)) {
      isScrolling.value = false;
      return;
    }

    scrollContainer.scrollBy({
      top: direction * scrollSpeed, // 위(-1) or 아래(+1) 이동
    });

    requestAnimationFrame(smoothScroll); // 반복 호출
  };

  if (!isScrolling.value) {
    isScrolling.value = true;
    smoothScroll();
  }
};
/* 아트워크 관리 모달 e */

</script>

<style scoped>

</style>